import { Axios } from "../../utils/axiosMiddleware";
import { SimpleCatchError } from "../../utils/Helper";

/**
 * Ledger statement for the authenticated user (`GET payment/me/statement`, user
 * derived from the JWT). One call returns the server-computed totals
 * `{ earned, spent, withdrawn, pending }` plus a flat, newest-first `entries[]`
 * ledger — the wallet screen reads its money from here (the plain user payload
 * carries no wallet object) and groups `entries` into its tabbed transaction
 * list. Returns the response data; undefined on error.
 */
export const getMyStatement = async () => {
  try {
    const response = await Axios.get("payment/me/statement");
    return response?.data;
  } catch (e) {
    SimpleCatchError(e);
  }
};
